const ActionButtonMode = {
  ADD: 'add',
  EDIT: 'edit',
  DELETE: 'delete',
  VIEW: 'view',
  SAVE: 'save',
  NONE: '',
};

export default ActionButtonMode;
